const getters = {
  getPaymentToInsurerTransaction: (state) => state.paymentToInsurerTransaction,
  getPaymentToInsurerTransactionList: (state) =>
    state.paymentToInsurerTransactionList,
  getPaymentToInsurerTransactionListMeta: (state) =>
    state.paymentToInsurerTransactionMeta,

  getInsurerBranchList: (state) => state.insurerBranchList,
  getSelectedInsurer: (state) => state.selectedInsurer,
  getFetchParameter: (state) => state.fetchParameter,
};

export default getters;
